/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} License_StatusInputs */

const en_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`License status: ${i?.status}`)
};

const fr_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Statut de la licence : ${i?.status}`)
};

const de_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lizenzstatus: ${i?.status}`)
};

const it_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stato della licenza: ${i?.status}`)
};

const ru_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Статус лицензии: ${i?.status}`)
};

const es_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estado de la licencia: ${i?.status}`)
};

const zh_cn2_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`许可证状态：${i?.status}`)
};

const ja_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ライセンスステータス: ${i?.status}`)
};

const hi_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लाइसेंस स्थिति: ${i?.status}`)
};

const pt_pt2_license_status = /** @type {(inputs: License_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status da licença: ${i?.status}`)
};

/**
* | output |
* | --- |
* | "License status: {status}" |
*
* @param {License_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_status = /** @type {((inputs: License_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_license_status(inputs)
	if (locale === "de") return de_license_status(inputs)
	if (locale === "it") return it_license_status(inputs)
	if (locale === "ru") return ru_license_status(inputs)
	if (locale === "es") return es_license_status(inputs)
	if (locale === "zh-CN") return zh_cn2_license_status(inputs)
	if (locale === "ja") return ja_license_status(inputs)
	if (locale === "hi") return hi_license_status(inputs)
	if (locale === "pt-PT") return pt_pt2_license_status(inputs)
	return en_license_status(inputs)
});